import React from 'react'
import PropTypes from 'prop-types'
import { Formik } from 'formik'
import { Paper, Typography, FormControl } from '@material-ui/core'
import { useStyles } from './two-fa-user-login.styles'
import { ITwoFaLoginUserInput } from 'app/shared/data-access/users/two-fa-login-user/ITwoFaLoginUserInput'
import {Link, NavLink} from 'react-router-dom'
import OtpTokenEntry from '../user/edit/otp-token-entry/otp-token-entry'

type Props = {
  onTwoFaLogin: (input: ITwoFaLoginUserInput) => Promise<void>
}

const TwoFaUserLoginTotpView = (props: Props) => {
  const classes = useStyles()

  return (
    <main className={classes.main}>
      <Paper className={classes.paper}>
        <Link to={{ pathname: `//axs-ict.com` }} target="_blank" >
            <img src="/axs_logo_payoff.png" className={classes.branding} alt="AXS logo" />
        </Link>
        <Typography component="h1" variant="h5">
          Tweestapsverificatie
        </Typography>
        <Formik
          initialValues={{ twoFaCode: '' } as ITwoFaLoginUserInput}
          onSubmit={async (values, { setSubmitting }) => {
            setSubmitting(false)
            await props.onTwoFaLogin(values)
          }}
        >
          {({ errors, touched, handleChange, handleSubmit }) => (
            <form className={classes.form} onSubmit={handleSubmit}>
              <FormControl required fullWidth>
                <p>Voer de 2FA code in van de authenticator app die je gebruikt hebt.</p>
                <OtpTokenEntry
                  length={6}
                  onTokenEntered={(token: string) => {
                    handleChange('twoFaCode')(token)
                    handleSubmit()
                  }}
                />
                {errors.twoFaCode && touched.twoFaCode && errors.twoFaCode}
              </FormControl>
              <NavLink to="/login">Terug naar inloggen</NavLink>
            </form>
          )}
        </Formik>
      </Paper>
    </main>
  )
}

TwoFaUserLoginTotpView.propTypes = {
  onTwoFaLogin: PropTypes.func,
}

export default TwoFaUserLoginTotpView
